import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Field, reduxForm } from 'redux-form';
import './main.less';

import ModalBox from '../../../shared/modal';
import Input from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select/field';
import Checkbox from '../../../shared/form-elements/checkbox';
import { createSelectOptionsFromSysEnums } from '../../../shared/form-elements/select';

const Form = props => {
	const submit = data => props.submitConversionsStatusChange(data).then(props.apply);
	return (
		<div className='display-flex-column'>
			<form className='ui-form payouts-form__main clearfix display-flex-column' onSubmit={props.handleSubmit(submit)}>
				<div className="ui-form__element">
					<Field
						name="ids"
						placeholder={props.intl('Conversion ids separated by comma (i.e. 100, 101, 102)')}
						component={Input}
						showLabel={false}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="payout"
						type="number"
						placeholder={props.intl('Conversion payout')}
						component={Input}
						showLabel={false}
						errors={props.errors}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="status"
						placeholder={props.intl('Status (only between non approved statuses)')}
						component={SelectField}
						options={createSelectOptionsFromSysEnums(props.conversionStatusOptions)}
						showLabel={false}
						searchable={false}
						errors={props.errors}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="cancellation_reason"
						placeholder={props.intl('Cancellation reason')}
						component={SelectField}
						options={createSelectOptionsFromSysEnums(props.conversionCancellationReasons)}
						showLabel={false}
						searchable={false}
						errors={props.errors}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="need_send_postbacks"
						placeholder={props.intl('Need send postback?')}
						component={Checkbox}
						showLabel={false}
					/>
				</div>
				<div className="display-flex">
					<button
						className={cn({ 'ui-btn': true, 'ui-btn-primary apply': true })}
						type='submit'
					>
						{props.intl('Apply')}
					</button>
					<button
						className='ui-btn ui-btn-cancel cancel'
						onClick={e => {
							e.preventDefault();
							props.toggleStatusChangeForm();
						}}
					>{props.intl('Cancel')}</button>
				</div>
			</form>
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Conversions status change')}
		body={Form(props)}
		isOpen={props.isStatusChangeFormShowed}
		onClose={props.toggleStatusChangeForm}
		className='form-modal conversion-status-change-modal'
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({ form: 'conversionsStatusChangeForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/change-status-form/main.js